// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1d8Sp","header":"MessagesList_header__L2fIk","chat":"MessagesList_chat__36pSk"};